import React, { useEffect, useState } from 'react';
import Header from '../../layouts/Header';
import { Col, Form, Row, Button, Dropdown, Modal, Spinner, Card, ListGroup, Table, Badge, Accordion, InputGroup } from 'react-bootstrap';
import ReusableTable from '../../components/ReusableTable';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import makeAnimated from "react-select/animated";
import { format, isAfter, isBefore, parseISO } from 'date-fns';
import * as XLSX from 'xlsx';
import MultiSelectComponent from '../../components/MultiSelectComponent'
import debounce from 'lodash/debounce';
import EditModal from './EditModal';
import { useSelector } from 'react-redux';
import { reverse } from 'lodash';

const NewUserCoupon = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [couponAccess, setCouponAccess] = useState([]);
    const [activeAccordion, setActiveAccordion] = useState(null);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("UserCouponAllocation:")
            );
            setCouponAccess(filteredAccess);
        }
    }, [access]);

    console.log("Menu Access:", couponAccess);

    const accessToken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const [usersList, setUsersList] = useState([]);
    const [usersFromFile, setUsersFromFile] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [couponData, setCouponData] = useState({
        isBogoCoupon: false,
        isSizeUpgradeCoupon: false,
        sizeUpgradeAddon: "",
        newSizeUpgradeAddon: "",
        title: "",
        description: "",
        usageType: "",
        orderType: "ALL",
        couponCode: "",
        discountPercent: "",
        dayOfWeek: "",
        discountAmount: "",
        validityStartDate: "",
        validityEndDate: "",
        dailyUsageLimit: "",
        startTime: "",
        endTime: "",
        discountPrice: "",
        applicableQuantityType: "",
        termsAndConditions: [], // Array to store terms
        isComboCategoryCoupon: false,
        maxAddonsAllowed: null,
        maxDiscountAmount: "",
        minOrderAmount: "",
        isMrpDiscount: false,
        isFreebieCoupon: false, // Add this
        freebieProduct: "", // Add this
        freebieQuantity: "", // Add this
        excludedAddons: [] // Add excludedAddons array to couponData
    });
    const [selections, setSelections] = useState({
        selectedIncludedOutlets: [],
        selectedExcludedOutlets: [],
        selectedApplicableCategories: [],
        selectedApplicableProducts: [],
        selectedDependentCategories: [],
        selectedDependentProducts: [],
        selectedExcludedProducts: [],
        selectedApplicableLevels: [],
        primaryComboCategories: [],
        secondaryComboCategories: []
    });
    const [currentTerm, setCurrentTerm] = useState('');
    const [addonList, setAddonList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [addNewOpenModal, setAddNewOpenModal] = useState(false);
    const [userCouponAllocationData, setUserCouponAllocationData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [couponUsers, setCouponUsers] = useState([]);
    const [couponDetails, setCouponDetails] = useState({});
    const [openEditModal, setOpenEditModal] = useState(false);
    const [userCouponId, setUserCouponId] = useState("");
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [userCouponAllocationId, setUserCouponAllocationId] = useState("");
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
    const [file, setFile] = useState(null);
    const [outlets, setOutlets] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedIncludedOptions, setSelectedIncludedOptions] = useState([]);
    const [selectedLevelOptions, setSelectedLevelOptions] = useState([]);
    const [levels, setLevels] = useState([]);
    const [primaryComboCategories, setPrimaryComboCategories] = useState([])
    const [secondaryComboCategories, setSecondaryComboCategories] = useState([]);
    const [editSelections, setEditSelections] = useState({
        selectedIncludedOutlets: [],
        selectedExcludedOutlets: [],
        selectedAddonValues: [],
        selectedApplicableLevels: [],
        primaryComboCategories: [],
        secondaryComboCategories: []
    });
    const [updatingData, setUpdatingData] = useState(null);
    const [exProductList, setExProductList] = useState([]);
    const [selectedDependentCategories, setSelectedDependentCategories] = useState([]);
    const [selectedDependentProducts, setSelectedDependentProducts] = useState([]);
    const [selectedExcludedProducts, setSelectedExcludedProducts] = useState([]);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [newSizeAddonsList, setNewSizeAddonsList] = useState([]);
    const [newProductsFromAddons, setNewProductsFromAddons] = useState([]);
    const [allAddonList, setAllAddonList] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);
    const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);
    const [selectedAddonValues, setSelectedAddonValues] = useState([]);

    // Grouped data for accordion
    const [groupedCouponData, setGroupedCouponData] = useState({});
    const [expandedCoupons, setExpandedCoupons] = useState({});

    // Filter states
    const [statusFilter, setStatusFilter] = useState('ALL');
    const [dateFilter, setDateFilter] = useState('ALL');

    const formattedDate = (string) => {
        return string?.split("T")[0];
    }

    // Group user coupon allocations by coupon
    const groupByCoupon = (data) => {
        const grouped = {};

        data.forEach((allocation) => {
            const couponId = allocation?.coupon_id?._id;
            if (!couponId) return;

            if (!grouped[couponId]) {
                grouped[couponId] = {
                    coupon: allocation.coupon_id,
                    allocations: [],
                    users: []
                };
            }

            grouped[couponId].allocations.push(allocation);
            if (allocation.user) {
                grouped[couponId].users.push({
                    user: allocation.user,
                    allocationId: allocation._id,
                    createdAt: allocation.createdAt
                });
            }
        });

        return grouped;
    };

    // Check if coupon is active based on validity dates
    const checkCouponActive = (coupon) => {
        if (!coupon) return false;

        const today = new Date();
        const startDate = coupon.validityStartDate ? parseISO(coupon.validityStartDate) : null;
        const endDate = coupon.validityEndDate ? parseISO(coupon.validityEndDate) : null;

        if (!endDate) return false;

        // Check if today is before end date (not expired)
        return isBefore(today, endDate) || isSameDay(today, endDate);
    };

    // Helper function to check if two dates are the same day
    const isSameDay = (date1, date2) => {
        return date1.getDate() === date2.getDate() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getFullYear() === date2.getFullYear();
    };

    // Apply filters to data
    const applyFilters = (data) => {
        let filtered = [...data];

        // Apply status filter
        if (statusFilter !== 'ALL') {
            filtered = filtered.filter(item => {
                const isActive = checkCouponActive(item?.coupon_id);
                return statusFilter === 'ACTIVE' ? isActive : !isActive;
            });
        }

        // Apply date filter
        if (dateFilter !== 'ALL') {
            const today = new Date();
            filtered = filtered.filter(item => {
                const coupon = item?.coupon_id;
                if (!coupon?.validityStartDate || !coupon?.validityEndDate) return false;

                const startDate = parseISO(coupon.validityStartDate);
                const endDate = parseISO(coupon.validityEndDate);

                switch (dateFilter) {
                    case 'EXPIRED':
                        return isAfter(today, endDate);
                    case 'UPCOMING':
                        return isAfter(startDate, today);
                    case 'CURRENT':
                        return (isBefore(today, endDate) || isSameDay(today, endDate)) &&
                            (isAfter(today, startDate) || isSameDay(today, startDate));
                    default:
                        return true;
                }
            });
        }

        // Apply search filter
        if (searchText.trim() !== '') {
            const query = searchText.toLowerCase();
            filtered = filtered.filter((item) => {
                const coupon = item?.coupon_id;
                const user = item?.user;

                return (
                    coupon?.couponCode?.toLowerCase().includes(query) ||
                    coupon?.title?.toLowerCase().includes(query) ||
                    coupon?.usageType?.toLowerCase().includes(query) ||
                    user?.name?.toLowerCase().includes(query) ||
                    user?.email?.toLowerCase().includes(query) ||
                    user?.mobile?.includes(query)
                );
            });
        }

        return filtered;
    };

    // Toggle accordion
    const toggleAccordion = (couponId) => {
        setExpandedCoupons(prev => ({
            ...prev,
            [couponId]: !prev[couponId]
        }));
    };

    const addTerm = () => {
        if (!currentTerm.trim()) return;
        setCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: Array.isArray(prevData.termsAndConditions)
                ? [...prevData.termsAndConditions, currentTerm]
                : [currentTerm],
        }));
        setCurrentTerm('');
    };

    const removeTerm = (index) => {
        setCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: Array.isArray(prevData.termsAndConditions)
                ? prevData.termsAndConditions.filter((_, i) => i !== index)
                : [],
        }));
    };

    const usersInfo = usersList.map((user) => ({
        value: user?._id,
        label: `${user?.name}, ${user?.mobile}`
    }));

    const freebieProductsOptions = productsList
        .filter(product => product.isFreebieProduct === true)
        .map((product) => ({
            value: product?._id,
            label: `${product?.name}`
        }));

    const productsInfo = productsList
        .filter(product => product?.isFreebieProduct === false)
        .map(product => ({
            value: product?._id,
            label: product?.name
        }));

    const exProductsInfo = exProductList
        .filter(product => product?.isFreebieProduct === false)
        .map(product => ({
            value: product?._id,
            label: product?.name
        }));

    const categoriesData = categoryList.map((category) => ({
        value: category._id,
        label: `${category.name}`
    }));

    const outletData = outlets
        .filter(
            (outlet) =>
                !selectedOptions.some((selected) => selected.value === outlet._id) &&
                !selectedIncludedOptions.some((selected) => selected.value === outlet._id)
        )
        .map((outlet) => ({
            value: outlet._id,
            label: `${outlet.name} (${outlet.city})`,
        }));

    const editOutletData = outlets
        .filter((outlet) => {
            const isExcluded = editSelections?.selectedExcludedOutlets?.some(
                (excludedOutlet) => excludedOutlet.value === outlet._id
            );

            const isIncluded = editSelections?.selectedIncludedOutlets?.some(
                (includedOutlet) => includedOutlet.value === outlet._id
            );

            return !isExcluded && !isIncluded;
        })
        .map((outlet) => ({
            value: outlet._id,
            label: `${outlet.name} (${outlet.city})`,
        }));

    const levelsData = levels.map((level) => ({
        value: level._id,
        label: `${level.sequenceNo}. ${level.title}`
    }));

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: '6px',
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d"
        }),
    };

    const checkboxes = [
        { id: "isBogoCoupon", label: "Bogo Coupon", field: "isBogoCoupon" },
        { id: "isSizeUpgradeCoupon", label: "Size Upgrade Coupon", field: "isSizeUpgradeCoupon" },
        { id: "isComboCategoryCoupon", label: "Combo Coupon", field: "isComboCategoryCoupon" },
        { id: "isMRPCoupon", label: "MRP Coupon", field: "isMrpDiscount" },
        { id: "isFreebieCoupon", label: "Freebie Coupon", field: "isFreebieCoupon" },
    ];

    const handleCheckboxChange = (field) => (e) => {
        const currentUsers = selectedUsers;

        resetFields();

        setSelectedUsers(currentUsers);

        setCouponData((prev) => ({
            ...prev,
            [field]: e.target.checked,
            isBogoCoupon: field === "isBogoCoupon" ? e.target.checked : false,
            isSizeUpgradeCoupon: field === "isSizeUpgradeCoupon" ? e.target.checked : false,
            isComboCategoryCoupon: field === "isComboCategoryCoupon" ? e.target.checked : false,
            isMrpDiscount: field === "isMrpDiscount" ? e.target.checked : false,
            isFreebieCoupon: field === "isFreebieCoupon" ? e.target.checked : false,
        }));
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const resetFields = () => {
        setCouponData({
            isBogoCoupon: false,
            isSizeUpgradeCoupon: false,
            isFreebieCoupon: false,
            freebieProduct: "",
            freebieQuantity: "",
            sizeUpgradeAddon: "",
            title: "",
            description: "",
            usageType: "",
            couponCode: "",
            discountPercent: "",
            dayOfWeek: "",
            discountAmount: "",
            validityStartDate: "",
            validityEndDate: "",
            startTime: "",
            endTime: "",
            discountPrice: "",
            applicableQuantityType: "",
            applicableProducts: [],
            termsAndConditions: [],
            isComboCategoryCoupon: false,
            maxAddonsAllowed: null,
            maxDiscountAmount: "",
            minOrderAmount: "",
            isMrpDiscount: false,
            excludedAddons: []
        });

        setSelections({
            selectedIncludedOutlets: [],
            selectedExcludedOutlets: [],
            selectedApplicableCategories: [],
            selectedApplicableProducts: [],
            selectedDependentCategories: [],
            selectedDependentProducts: [],
            selectedExcludedProducts: [],
            selectedApplicableLevels: [],
            primaryComboCategories: [],
            secondaryComboCategories: []
        });

        setFile(null);
        setFromDate(null);
        setToDate(null);
        setSelectedCategories([]);
        setSelectedProducts([]);
        setSelectedUsers([]);
        setSelectedAddonGroups([]);
        setSelectedAddonValues([]);
        setFilteredAddonValues([]);
    }

    const handleDeleteModal = async (data) => {
        setOpenDeleteModal(true);
        setUserCouponAllocationId(data?._id);
    };

    const handleDeleteUserCouponAllocation = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: userCouponAllocationId,
            };
            const response = await axios.delete(`user-coupon-allocation`, { data, headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setOpenDeleteModal(false);
            }
            fetchData();
        } catch (error) {
            console.log(error.response);

            if (error.response.status === 403) {
                toast.error(error?.response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false)
    };

    const handleAddNewOpenModal = () => {
        setAddNewOpenModal(true);
        setCouponData({
            isBogoCoupon: false,
            isSizeUpgradeCoupon: false,
            isFreebieCoupon: false,
            freebieProduct: "",
            freebieQuantity: "",
            sizeUpgradeAddon: "",
            title: "",
            description: "",
            usageType: "",
            couponCode: "",
            discountPercent: "",
            discountAmount: "",
            validityStartDate: "",
            validityEndDate: "",
            discountPrice: "",
            applicableQuantityType: "",
            applicableProducts: [],
            excludedAddons: []
        });
        setFile(null);
        setFromDate(null);
        setToDate(null);
        setSelectedCategories([]);
        setSelectedProducts([]);
        setSelectedUsers([]);
        setSelectedAddonGroups([]);
        setSelectedAddonValues([]);
        setFilteredAddonValues([]);
    };

    const handleCloseAddNewOpenModal = () => {
        setAddNewOpenModal(false);
        resetFields()
    };

    const handleInputChange = (e) => {
        const { name, value, type } = e.target;
        const updatedCouponCode = name === "couponCode" ? value.toUpperCase() : value
        setCouponData((prev) => {
            const updatedData = {
                ...prev,
                [name]: type === "number" ? parseFloat(value) || "" : updatedCouponCode,
            };
            return updatedData;
        });
    };

    const handleSelectUsersChange = (users) => {
        setSelectedUsers(users);
    };

    const handleSelectCategoryChange = (cats) => {
        setSelectedCategories(cats);
    };

    const handleSelectProductChange = (products) => {
        setSelectedProducts(products);
    };

    const handleFromDateChange = (date) => {
        if (date) {
            setFromDate(date);
        } else {
            console.error("Received null or undefined date");
        }
    };

    const handleToDateChange = (date) => {
        if (date) {
            setToDate(date);
        } else {
            console.error("Received null or undefined date");
        }
    };

    const getAddonList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("addons?page=1&limit=100", { headers });
            console.log("Response of all addons :", response?.data?.data);

            if (response?.data?.status === true) {
                console.log("Response of all addons :", response?.data?.data?.addons);
                setAllAddonList(response?.data?.data?.addons);
            }
        } catch (error) {
            toast.error(error?.response?.data?.error || "Failed to fetch addons", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    const getUsersList = async (query) => {
        if (!query) {
            setUsersList([]);
            return;
        }
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`user?search=${query}`, { headers });
            if (response?.data?.status === true) {
                const users = response?.data?.data?.users;
                setUsersList(users);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const debouncedGetUsersList = debounce(getUsersList, 500);

    const getProductsList = async (catId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product", { headers });
            if (response?.data?.status === true) {
                setProductsList(response?.data?.data?.products);

                console.log("Hello :");

                if (catId) {
                    let excludedProducts = response?.data?.data?.products?.filter((fi) =>
                        catId.some((category) => category.value === fi?.category?._id)
                    );
                    setExProductList(excludedProducts)
                } else {
                    setExProductList(response?.data?.data?.products);
                }

            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const getCategoryList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                setCategoryList(response?.data?.data?.categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const handleSubmitCoupon = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            let selectedUsersData

            if (selectedUsers.length > 0) {
                selectedUsersData = selectedUsers.map((c) => c.value);
            } else {
                selectedUsersData = usersFromFile
            }

            if (selectedUsersData?.length === 0) {
                toast.error("Users Required", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });

                return
            }

            if (couponData?.dayOfWeek === "" || couponData?.dayOfWeek === "all") {
                delete couponData.dayOfWeek
            }

            if (!couponData.validityStartDate && !couponData?.validityEndDate) {
                toast.error("Please provide start date and end date for the coupon validity.", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                return
            }

            if (couponData.isFreebieCoupon) {
                if (!couponData.freebieProduct) {
                    toast.error("Please select a freebie product", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                    setIsLoading(false);
                    return;
                }

                if (!couponData.freebieQuantity || couponData.freebieQuantity <= 0) {
                    toast.error("Please enter a valid freebie quantity", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                    setIsLoading(false);
                    return;
                }
            }

            if (!couponData.validityStartDate && couponData?.validityEndDate) {
                toast.error("Please select a start date for the coupon validity.", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                return
            }

            if (couponData.validityStartDate && !couponData?.validityEndDate) {
                toast.error("Please select a end date for the coupon validity.", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                return
            }

            const selectedIncludedOutlets = selections?.selectedIncludedOutlets?.map((option) => option.value) || [];
            const selectedExcludedOutlets = selections?.selectedExcludedOutlets?.map((option) => option.value) || [];
            const selectedApplicableCategories = selections?.selectedApplicableCategories?.map((option) => option.value) || [];
            const selectedApplicableProducts = selections?.selectedApplicableProducts?.map((option) => option.value) || [];
            const selectedApplicableLevels = selections?.selectedApplicableLevels?.map((option) => option.value) || [];
            const selectedDependentCategories = selections?.selectedDependentCategories?.map((option) => option.value) || [];
            const selectedDependentProducts = selections?.selectedDependentProducts?.map((option) => option.value) || [];
            const selectedExcludedProducts = selections?.selectedExcludedProducts?.map((option) => option.value) || [];
            const selectedPrimaryComboCategories = selections?.primaryComboCategories?.map((option) => option.value) || [];
            const selectedSecondaryComboCategories = selections?.secondaryComboCategories?.map((option) => option.value) || [];

            let updatedCouponData = {
                ...couponData,
                excludedOutlets: selectedExcludedOutlets,
                includedOutlets: selectedIncludedOutlets,
                applicableLevels: selectedApplicableLevels,
            };

            if (couponData.isFreebieCoupon) {
                delete updatedCouponData.discountPercent;
                delete updatedCouponData.discountAmount;
                delete updatedCouponData.maxDiscountAmount;
                delete updatedCouponData.discountPrice;
                delete updatedCouponData.isMrpDiscount;
                delete updatedCouponData.applicableQuantityType;
                delete updatedCouponData.isBogoCoupon;
                delete updatedCouponData.isSizeUpgradeCoupon;
                delete updatedCouponData.isComboCategoryCoupon;
            }

            if (selectedPrimaryComboCategories.length > 0) {
                updatedCouponData.primaryComboCategories = selectedPrimaryComboCategories
            }
            if (selectedSecondaryComboCategories.length > 0) {
                updatedCouponData.secondaryComboCategories = selectedSecondaryComboCategories
            }
            if (selectedDependentCategories.length > 0) updatedCouponData.dependantCategories = selectedDependentCategories

            if (selectedDependentProducts.length > 0) updatedCouponData.dependantProducts = selectedDependentProducts

            if (selectedExcludedProducts.length > 0) updatedCouponData.excludedProductList = selectedExcludedProducts

            if (selectedApplicableProducts.length > 0) updatedCouponData.applicableProducts = selectedApplicableProducts

            if (selectedApplicableCategories.length > 0) updatedCouponData.applicableCategories = selectedApplicableCategories

            Object.keys(updatedCouponData).forEach((key) => {
                if (Array.isArray(updatedCouponData[key]) && updatedCouponData[key].length === 0) {
                    delete updatedCouponData[key];
                }
            });

            if (updatedCouponData?.discountAmount) {
                delete updatedCouponData.discountPercent;
                delete updatedCouponData.applicableProducts;
                delete updatedCouponData.isSizeUpgradeCoupon;
                delete updatedCouponData.sizeUpgradeAddon;
                delete updatedCouponData.applicableQuantityType
            }

            if (updatedCouponData?.discountPercent) {
                delete updatedCouponData.discountAmount;
                delete updatedCouponData.applicableProducts;
                delete updatedCouponData.isSizeUpgradeCoupon;
                delete updatedCouponData.sizeUpgradeAddon;
                delete updatedCouponData.applicableQuantityType
            }

            if (updatedCouponData.isBogoCoupon) {
                delete updatedCouponData.applicableProducts;
                delete updatedCouponData.discountPercent;
                delete updatedCouponData.discountAmount;
                delete updatedCouponData.discountPrice;
                delete updatedCouponData.applicableQuantityType;
                delete updatedCouponData.isSizeUpgradeCoupon;
                delete updatedCouponData.sizeUpgradeAddon;
            } else {
                delete updatedCouponData.isBogoCoupon;
            }

            if (updatedCouponData.isSizeUpgradeCoupon) {
                delete updatedCouponData.discountPercent;
                delete updatedCouponData.discountAmount;
                delete updatedCouponData.discountPrice;
                delete updatedCouponData.applicableQuantityType;
            }

            if (Array.isArray(updatedCouponData.termsAndConditions) && updatedCouponData.termsAndConditions.length === 0) {
                delete updatedCouponData.termsAndConditions;
            }

            let newCouponData = {
                ...updatedCouponData,
            };

            newCouponData = Object.fromEntries(
                Object.entries(newCouponData).filter(
                    ([_, value]) => value !== null && value !== undefined && value !== ""
                )
            );

            const response = await axios.post("coupons", newCouponData, { headers });

            if (response?.data?.status === true) {
                const couponId = response?.data?.data?.dbResponse?._id;
                await handleSubmitUserCoupon(couponId);
                resetFields()
            }
        } catch (error) {
            let errorMessage = 'An error occurred';
            console.log(error.response);

            if (error?.response) {
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error || error?.response?.data?.data?.title
                } else if (error.response?.status === 412 || error?.response?.status === 404) {
                    errorMessage = error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
            }
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmitUserCoupon = async (couponId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            let selectedUsersData

            if (selectedUsers.length > 0) {
                selectedUsersData = selectedUsers.map((c) => c.value);
            } else {
                selectedUsersData = usersFromFile
            }

            if (selectedUsersData?.length === 0) {
                toast.error("Users Required", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });

                return
            }

            const data = {
                users: selectedUsersData,
                coupon_id: couponId
            }

            const response = await axios.post("user-coupon-allocation", data, {
                headers,
            });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                fetchData();
                getProductsList();
                setCouponData({
                    isBogoCoupon: false,
                    isSizeUpgradeCoupon: false,
                    isFreebieCoupon: false,
                    freebieProduct: "",
                    freebieQuantity: "",
                    sizeUpgradeAddon: "",
                    title: "",
                    description: "",
                    usageType: "",
                    orderType: "ALL",
                    couponCode: "",
                    discountPercent: "",
                    discountAmount: "",
                    validityStartDate: "",
                    validityEndDate: "",
                    discountPrice: "",
                    applicableQuantityType: "",
                    applicableProducts: [],
                    termsAndConditions: [],
                    isComboCategoryCoupon: false,
                    maxAddonsAllowed: null,
                    maxDiscountAmount: "",
                    minOrderAmount: "",
                    isMrpDiscount: false,
                    excludedAddons: []
                });
                setPrimaryComboCategories([]);
                setSecondaryComboCategories([]);
                setExProductList([]);
                setSelectedDependentCategories([]);
                setSelectedDependentProducts([]);
                setSelectedExcludedProducts([])
                setSelectedCategories([])
                setSelectedProducts([])
                setSelectedUsers([]);
                setFromDate(null);
                setToDate(null);
                setSelectedAddonGroups([]);
                setSelectedAddonValues([]);
                setFilteredAddonValues([]);
                handleCloseAddNewOpenModal()
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412 || error?.response?.status === 404
                ) {
                    errorMessage = error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const fetchData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("user-coupon-allocation", { headers });
            if (response?.data?.status === true) {
                let responseData = [...response?.data?.data?.userCouponAllocations];
                responseData = responseData.reverse();

                const filtered = applyFilters(responseData);
                const grouped = groupByCoupon(filtered);

                setUserCouponAllocationData(responseData);
                setGroupedCouponData(grouped);
                setFilteredData(filtered);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("outlet", { headers });

            if (response?.data?.status === true) {
                setOutlets(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const getLevels = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("level", { headers });
            if (response?.data?.status === true) {
                const levels = response?.data?.data?.levels;
                setLevels(levels)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                })

            }
        }
    };

    const handleOpenViewModal = (couponData) => {
        setOpenViewModal(true);
        setCouponDetails(couponData);

        const users = groupedCouponData[couponData._id]?.users.map(u => u.user) || [];
        setCouponUsers(users);
    };

    const handleOpenEditModal = (allocationData) => {
        console.log('Edit Modal Data :', allocationData);
        setUpdatingData(allocationData);
        setOpenEditModal(true);
    };

    const getAddonProductsList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product-addon?limit=1000&page=1", { headers });
            if (response?.data?.status === true) {
                const addOns = response?.data?.data?.productAddons
                const productsWithSizeAddon = addOns.filter((item) =>
                    item.addons.some((addon) => addon.addonTitle.toLowerCase() === 'size')
                );
                setAddonList(productsWithSizeAddon)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const handleFileUpload = (file) => {
        if (!file) {
            alert("Please select a file.");
            return;
        }

        const allowedFileTypes = [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        const maxSizeInMB = 5;

        if (!allowedFileTypes.includes(file.type)) {
            alert("Invalid file type. Please upload a Excel file.");
            return;
        }

        if (file.size > maxSizeInMB * 1024 * 1024) {
            alert(`File size should not exceed ${maxSizeInMB} MB.`);
            return;
        }
        setFile(file);
        parseExcelFile(file);
    };

    const parseExcelFile = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const userIds = rows
                .filter((row, index) => index !== 0 && row[5] !== "ID")
                .map(row => row[5])
                .filter(id => id);

            setUsersFromFile(userIds);
        };
        reader.readAsArrayBuffer(file);
    };

    const filteredAddons = selections?.selectedApplicableProducts
        ? addonList.filter(rm => rm.product._id === selections?.selectedApplicableProducts[0]?.value)
        : [];
    const updatedFilteredAddons = filteredAddons?.map((item) => item.addons?.map((mm) => mm));

    const handlePageChange = (page) => {
        setPagination({ ...pagination, page });
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPagination({ page: 1, rowsPerPage });
    };

    const getDayOfWeek = (index) => {
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return days[index] || "Invalid day";
    };

    const getPaginatedData = () => {
        const startIndex = (pagination.page - 1) * pagination.rowsPerPage;
        const endIndex = startIndex + pagination.rowsPerPage;
        return filteredData.slice(startIndex, endIndex);
    };

    const handleChange = (key, value) => {
        setSelections((prev) => ({
            ...prev,
            [key]: value,
        }));

        if (key === "selectedApplicableCategories") {
            getProductsList(value);
        }
    };

    const addonsProducts = newProductsFromAddons?.map((item) => ({
        value: item?._id,
        label: item?.name
    }))

    const exAddonsProducts = newProductsFromAddons?.map((item) => ({
        value: item?._id,
        label: item?.name
    }))

    const getNewSizeAddons = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get('/product/getSizeUpgradeAddonsWithProducts', { headers });
            console.log("Response of new size addons :", response?.data?.data);
            setNewSizeAddonsList(response?.data?.data?.addons);
            let newproducts = response?.data?.data?.addons?.flatMap((add) => add?.products || []);
            setNewProductsFromAddons(newproducts);
        } catch (error) {
            console.log("Error :", error);
        }
    }

    const handleSelectAllAddonChange = (type, selectedOptions) => {
        if (type === 'excludedAddonGroups') {
            setSelectedAddonGroups(selectedOptions || []);

            if (selectedOptions && selectedOptions.length > 0) {
                const selectedGroupIds = selectedOptions.map(option => option.value);
                const valuesFromSelectedGroups = allAddonList
                    .filter(addon => selectedGroupIds.includes(addon._id))
                    .flatMap(addon =>
                        addon.addonValues.map(value => ({
                            value: {
                                addonId: addon._id,
                                addonValueId: value._id,
                                addonTitle: addon.title,
                                addonValueTitle: value.value
                            },
                            label: `${addon.title} - ${value.value}`
                        }))
                    );
                setFilteredAddonValues(valuesFromSelectedGroups);
            } else {
                setFilteredAddonValues([]);
                setSelectedAddonValues([]);
            }
        }
    };

    const handleAddonValueChange = (selectedOptions) => {
        setSelectedAddonValues(selectedOptions || []);

        const excludedAddons = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setCouponData(prev => ({
            ...prev,
            excludedAddons: excludedAddons
        }));
    };

    const handleStatusFilterChange = (status) => {
        setStatusFilter(status);
    };

    const handleDateFilterChange = (dateType) => {
        setDateFilter(dateType);
    };

    useEffect(() => {
        if (userCouponAllocationData.length > 0) {
            const filtered = applyFilters(userCouponAllocationData);
            const grouped = groupByCoupon(filtered);
            setGroupedCouponData(grouped);
            setFilteredData(filtered);
        }
    }, [statusFilter, dateFilter, searchText, userCouponAllocationData]);

    useEffect(() => {
        getUsersList();
        getProductsList();
        getCategoryList();
        fetchData();
        getAddonProductsList();
        getOutlets();
        getLevels();
        getNewSizeAddons();
        getAddonList();
    }, []);

    useEffect(() => {
        const formattedStartDate = fromDate ? format(fromDate, "yyyy-MM-dd") : "";
        const formattedEndDate = toDate ? format(toDate, "yyyy-MM-dd") : "";

        setCouponData((prev) => ({
            ...prev,
            validityStartDate: formattedStartDate,
            validityEndDate: formattedEndDate,
        }));
    }, [fromDate, toDate]);

    const renderAccordionItems = () => {
        const couponEntries = Object.entries(groupedCouponData);

        if (couponEntries.length === 0) {
            return (
                <div className="text-center py-5">
                    <i className="ri-coupon-line" style={{ fontSize: '3rem', color: '#6c757d' }}></i>
                    <p className="mt-3 text-muted">No coupon allocations found</p>
                </div>
            );
        }

        return couponEntries.map(([couponId, data]) => {
            const coupon = data.coupon;
            const isActive = checkCouponActive(coupon);
            const isExpanded = expandedCoupons[couponId];
            const userCount = data.users.length;
            const startIndex = (pagination.page - 1) * pagination.rowsPerPage;
            const endIndex = startIndex + pagination.rowsPerPage;
            const paginatedUsers = data.users.slice(startIndex, endIndex);

            return (
                <Accordion.Item eventKey={couponId} key={couponId}>
                    <Accordion.Header onClick={() => toggleAccordion(couponId)}>
                        <div className="d-flex justify-content-between align-items-center w-100 me-3">
                            <div className="d-flex align-items-center">
                                <div className="me-3">
                                    <Badge bg={isActive ? "success" : "danger"}>
                                        {isActive ? "ACTIVE" : "INACTIVE"}
                                    </Badge>
                                </div>
                                <div>
                                    <h6 className="mb-0">{coupon.title}</h6>
                                    <small className="text-muted">
                                        Code: <span className="fw-bold text-primary">{coupon.couponCode}</span> •
                                        Type: {coupon.usageType} •
                                        Users: <Badge bg="info" className="ms-1">{userCount}</Badge>
                                    </small>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <span className="me-3 text-muted">
                                    {formattedDate(coupon.validityStartDate)} - {formattedDate(coupon.validityEndDate)}
                                </span>
                                <i className={`ri-arrow-down-s-line ${isExpanded ? 'rotate-180' : ''}`}></i>
                            </div>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className="mb-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h6 className="mb-0">Coupon Details</h6>
                                <div>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        className="me-2"
                                        onClick={() => handleOpenViewModal(coupon)}
                                    >
                                        <i className="ri-eye-line me-1"></i> View Details
                                    </Button>
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        onClick={() => {
                                            // You can implement add more users functionality here
                                        }}
                                    >
                                        <i className="ri-user-add-line me-1"></i> Add Users
                                    </Button>
                                </div>
                            </div>

                            <Row className="mb-3">
                                <Col md={4}>
                                    <small className="text-muted">Description:</small>
                                    <p className="mb-1">{coupon.description}</p>
                                </Col>
                                <Col md={2}>
                                    <small className="text-muted">Discount:</small>
                                    <p className="mb-1 fw-bold text-success">
                                        {coupon.discountPercent ? `${coupon.discountPercent}% OFF` :
                                            coupon.discountAmount ? `₹${coupon.discountAmount} OFF` :
                                                coupon.discountPrice ? `₹${coupon.discountPrice}` : 'N/A'}
                                    </p>
                                </Col>
                                <Col md={2}>
                                    <small className="text-muted">Min. Order:</small>
                                    <p className="mb-1">{coupon.minOrderAmount ? `₹${coupon.minOrderAmount}` : 'N/A'}</p>
                                </Col>
                                <Col md={2}>
                                    <small className="text-muted">Type:</small>
                                    <p className="mb-1">
                                        <Badge bg={
                                            coupon.isBogoCoupon ? 'warning' :
                                                coupon.isSizeUpgradeCoupon ? 'info' :
                                                    coupon.isFreebieCoupon ? 'success' :
                                                        coupon.isMrpDiscount ? 'secondary' : 'primary'
                                        }>
                                            {coupon.isBogoCoupon ? 'BOGO' :
                                                coupon.isSizeUpgradeCoupon ? 'Size Upgrade' :
                                                    coupon.isFreebieCoupon ? 'Freebie' :
                                                        coupon.isMrpDiscount ? 'MRP' : 'Regular'}
                                        </Badge>
                                    </p>
                                </Col>
                                <Col md={2}>
                                    <small className="text-muted">Usage Limit:</small>
                                    <p className="mb-1">{coupon.dailyUsageLimit || 'Unlimited'}</p>
                                </Col>
                            </Row>

                            {/* Users List */}
                            <div className="mt-4">
                                <h6 className="mb-3">Assigned Users ({userCount})</h6>

                                {userCount > 0 ? (
                                    <>
                                        <Table bordered hover size="sm" responsive>
                                            <thead className="bg-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Mobile</th>
                                                    <th>Assigned Date</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedUsers.map((userData, index) => (
                                                    <tr key={userData.allocationId}>
                                                        <td>{startIndex + index + 1}</td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <div className="avatar-sm me-2">
                                                                    <div className="avatar-title bg-light text-primary rounded-circle">
                                                                        {userData.user?.name?.charAt(0) || 'U'}
                                                                    </div>
                                                                </div>
                                                                <span>{userData.user?.name || 'N/A'}</span>
                                                            </div>
                                                        </td>
                                                        <td>{userData.user?.email || 'N/A'}</td>
                                                        <td>{userData.user?.mobile || 'N/A'}</td>
                                                        <td>{formattedDate(userData.createdAt)}</td>
                                                        <td>
                                                            <div className="d-flex gap-2">
                                                                {(couponAccess.includes("UserCouponAllocation:update") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="outline-primary"
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            const allocation = data.allocations.find(
                                                                                a => a._id === userData.allocationId
                                                                            );
                                                                            if (allocation) {
                                                                                handleOpenEditModal({
                                                                                    ...allocation,
                                                                                    coupon_id: coupon
                                                                                });
                                                                            }
                                                                        }}
                                                                    >
                                                                        <i className="ri-edit-line"></i>
                                                                    </Button>
                                                                )}
                                                                {(couponAccess.includes("UserCouponAllocation:delete") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            const allocation = data.allocations.find(
                                                                                a => a._id === userData.allocationId
                                                                            );
                                                                            if (allocation) {
                                                                                handleDeleteModal(allocation);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>

                                        {userCount > pagination.rowsPerPage && (
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <small className="text-muted">
                                                    Showing {startIndex + 1} to {Math.min(endIndex, userCount)} of {userCount} users
                                                </small>
                                                <div className="d-flex gap-2">
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        disabled={pagination.page === 1}
                                                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                                                    >
                                                        <i className="ri-arrow-left-line"></i> Previous
                                                    </Button>
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        disabled={endIndex >= userCount}
                                                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                                                    >
                                                        Next <i className="ri-arrow-right-line"></i>
                                                    </Button>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div className="text-center py-4">
                                        <i className="ri-user-unfollow-line" style={{ fontSize: '2rem', color: '#6c757d' }}></i>
                                        <p className="mt-2 text-muted">No users assigned to this coupon</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            );
        });
    };

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ backgroundColor: "white" }}
                >
                    <Row>
                        <Col className='mt-4'>
                            <h5 className="fw-semibold">USER COUPON ALLOCATION</h5>
                        </Col>
                        <hr />
                    </Row>

                    {/* Filters */}
                    <Row className="mb-3">
                        <Col md="3" lg="3" className="mb-3">
                            <div className="d-flex align-items-center mb-1">
                                <i className="ri-filter-line me-2 text-muted"></i>
                                <h6 className="mb-0">Status Filter</h6>
                            </div>
                            <div className="d-flex gap-2 mt-2">
                                <Button
                                    variant={statusFilter === 'ALL' ? 'primary' : 'outline-primary'}
                                    onClick={() => handleStatusFilterChange('ALL')}
                                >
                                    All
                                </Button>
                                <Button
                                    variant={statusFilter === 'ACTIVE' ? 'success' : 'outline-success'}
                                    onClick={() => handleStatusFilterChange('ACTIVE')}
                                >
                                    Active
                                </Button>
                                <Button
                                    variant={statusFilter === 'INACTIVE' ? 'danger' : 'outline-danger'}
                                    onClick={() => handleStatusFilterChange('INACTIVE')}
                                >
                                    Inactive
                                </Button>
                            </div>
                        </Col>

                        <Col md="4" lg="4">
                            <Form.Label className='text-white'>.</Form.Label>
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    className="form-control"
                                    placeholder="Search coupons or users..."
                                />
                                <button className="btn btn-primary" type="button">
                                    <i className="ri-search-line"></i>
                                </button>
                            </div>
                        </Col>

                        <Col md="4" lg="4" className="mb-3">
                            <div className="d-flex align-items-center mb-1">
                                <i className="ri-calendar-line me-2 text-muted"></i>
                                <h6 className="mb-0">Date Filter</h6>
                            </div>
                            <div className="d-flex gap-2">
                                <Button
                                    variant={dateFilter === 'ALL' ? 'secondary' : 'outline-secondary'}
                                    size="sm"
                                    onClick={() => handleDateFilterChange('ALL')}
                                >
                                    All
                                </Button>
                                <Button
                                    variant={dateFilter === 'CURRENT' ? 'info' : 'outline-info'}
                                    size="sm"
                                    onClick={() => handleDateFilterChange('CURRENT')}
                                >
                                    Current
                                </Button>
                                <Button
                                    variant={dateFilter === 'UPCOMING' ? 'warning' : 'outline-warning'}
                                    size="sm"
                                    onClick={() => handleDateFilterChange('UPCOMING')}
                                >
                                    Upcoming
                                </Button>
                                <Button
                                    variant={dateFilter === 'EXPIRED' ? 'danger' : 'outline-danger'}
                                    size="sm"
                                    onClick={() => handleDateFilterChange('EXPIRED')}
                                >
                                    Expired
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col className="d-flex justify-content-between align-items-center">
                            <div>
                                <small className="text-muted">
                                    Showing {Object.keys(groupedCouponData).length} coupons with {filteredData.length} user allocations
                                </small>
                            </div>
                            <div>
                                {(couponAccess.includes("UserCouponAllocation:add") || email === "contact@xpansecafe.com") && (
                                    <Button
                                        variant="primary"
                                        className="fw-semibold"
                                        onClick={handleAddNewOpenModal}
                                    >
                                        <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                        Allocate New Coupon To Users
                                    </Button>
                                )}
                            </div>
                        </Col>
                    </Row>

                    {/* Accordion View */}
                    <Row>
                        <Col>
                            <Accordion>
                                {renderAccordionItems()}
                            </Accordion>
                        </Col>
                    </Row>

                    {/* Add New Coupon Modal - Keep your existing modal */}
                    {addNewOpenModal && (
                        <Modal
                            show={addNewOpenModal}
                            onHide={handleCloseAddNewOpenModal}
                            centered
                            size="xl"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>ADD USER COUPON ALLOCATION</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleSubmitCoupon}>
                                <Modal.Body>
                                    {/* Your existing form content */}
                                    <Row className="mb-3">
                                        <Col md={12} className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Upload File (Excel)
                                            </Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept=".xls, .xlsx"
                                                onChange={(e) => handleFileUpload(e.target.files[0])}
                                            />
                                        </Col>

                                        <Col md={12} className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Select Users
                                            </Form.Label>
                                            <Select
                                                isDisabled={file}
                                                isMulti
                                                options={usersInfo}
                                                value={selectedUsers || []}
                                                onChange={handleSelectUsersChange}
                                                onInputChange={(query) => {
                                                    if (typeof query === "string") {
                                                        debouncedGetUsersList(query);
                                                    }
                                                }}
                                                placeholder="Select Users"
                                                closeMenuOnSelect={false}
                                                styles={customStyles}
                                            />
                                        </Col>
                                        <Card className="mb-4">
                                            <Card.Body>
                                                <Row className="g-3">
                                                    {checkboxes?.map(({ id, label, field }) => (
                                                        <Col md={2} key={id}>
                                                            <Form.Check
                                                                type="checkbox"
                                                                id={id}
                                                                label={label}
                                                                checked={couponData[field]}
                                                                onChange={handleCheckboxChange(field)}
                                                                className="custom-checkbox fw-semibold"
                                                            />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Card.Body>
                                        </Card>

                                        {/* TITLE FIELD */}
                                        <Col md={3}>
                                            <Form.Label className="fw-semibold">
                                                Title <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                placeholder="Title"
                                                name="title"
                                                value={couponData.title || ""}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {/* COUPON CODE */}
                                        <Col md={3}>
                                            <Form.Label className="fw-semibold">
                                                Coupon Code <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                placeholder="Coupon Code"
                                                name="couponCode"
                                                value={couponData.couponCode || ""}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {/* VALIDITY START DATE */}
                                        <Col md={2} className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Validity Start Date <span className="text-danger">*</span>
                                            </Form.Label>
                                            <DatePicker
                                                selected={fromDate}
                                                onChange={handleFromDateChange}
                                                placeholderText="Start Date"
                                                className="form-control"
                                            />
                                        </Col>

                                        {/* VALIDITY END DATE */}
                                        <Col md={2}>
                                            <Form.Label className="fw-semibold">
                                                Validity End Date <span className="text-danger">*</span>
                                            </Form.Label>
                                            <DatePicker
                                                selected={toDate}
                                                onChange={handleToDateChange}
                                                placeholderText="End Date"
                                                className="form-control"
                                            />
                                        </Col>

                                        <Col md={2}>
                                            <Form.Label className="fw-semibold">
                                                Daily Usage Limit
                                            </Form.Label>
                                            <Form.Control
                                                min={0}
                                                placeholder="Set Daily Usage Limit"
                                                name="dailyUsageLimit"
                                                value={couponData.dailyUsageLimit || ""}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {/* USAGE TYPE */}
                                        <Col md={3}>
                                            <Form.Label className="fw-semibold">
                                                Usage Type <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="usageType"
                                                value={couponData.usageType}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select Usage</option>
                                                <option value="ONE-TIME">ONE-TIME</option>
                                                <option value="MULTIPLE">MULTIPLE</option>
                                            </Form.Select>
                                        </Col>

                                        {/* SELECT DAY OF THE WEEK */}
                                        <Col md={3}>
                                            <Form.Label className="fw-semibold">
                                                Select Day of a week
                                            </Form.Label>
                                            <Form.Select
                                                onChange={handleInputChange}
                                                name="dayOfWeek"
                                                className="mb-3"
                                                aria-label="Small select example"
                                                value={couponData?.dayOfWeek}
                                            >
                                                <option value="">Select Day</option>
                                                <option value="0">SUNDAY</option>
                                                <option value="1">MONDAY</option>
                                                <option value="2">TUESDAY</option>
                                                <option value="3">WEDNESDAY</option>
                                                <option value="4">THURSDAY</option>
                                                <option value="5">FRIDAY</option>
                                                <option value="6">SATURDAY</option>
                                                <option value="all">ANY DAY OF THE WEEK</option>
                                            </Form.Select>
                                        </Col>

                                        {/* START TIME */}
                                        <Col md={3} lg={3}>
                                            <Form.Label className="fw-semibold">
                                                Start Time
                                            </Form.Label>
                                            <Form.Control
                                                type="time"
                                                placeholder="Opening Time"
                                                name="startTime"
                                                value={couponData.startTime}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {/* END TIME */}
                                        <Col md={3} lg={3}>
                                            <Form.Label className="fw-semibold">
                                                End Time
                                            </Form.Label>
                                            <Form.Control
                                                type="time"
                                                placeholder="Closing Time"
                                                name="endTime"
                                                value={couponData.endTime}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {couponData.isFreebieCoupon && (
                                            <>
                                                <Col md={4} className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Freebie Product <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        name="freebieProduct"
                                                        options={freebieProductsOptions}
                                                        value={freebieProductsOptions.find(option => option.value === couponData.freebieProduct) || null}
                                                        onChange={(selectedOption) => {
                                                            setCouponData(prev => ({
                                                                ...prev,
                                                                freebieProduct: selectedOption ? selectedOption.value : ""
                                                            }));
                                                        }}
                                                        isClearable
                                                        placeholder="Select Freebie Product"
                                                        classNamePrefix="react-select"
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
                                                                boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
                                                                "&:hover": {
                                                                    borderColor: state.isFocused ? "#80bdff" : "#ced4da",
                                                                },
                                                            }),
                                                        }}
                                                    />
                                                </Col>

                                                <Col md={2} className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Freebie Quantity <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="1"
                                                        name="freebieQuantity"
                                                        value={couponData.freebieQuantity || ""}
                                                        onChange={handleInputChange}
                                                        placeholder="Quantity"
                                                    />
                                                </Col>
                                            </>
                                        )}

                                        {/* SELECT INCLUDED OUTLETS */}
                                        <MultiSelectComponent
                                            label="Select Included Outlets"
                                            placeholder="Select Included Outlets"
                                            options={outletData.filter(
                                                (outlet) =>
                                                    !selections?.selectedExcludedOutlets?.some(
                                                        (excludedOutlet) => excludedOutlet.value === outlet.value
                                                    )
                                            )}
                                            value={selections?.selectedIncludedOutlets || []}
                                            onChange={(value) => handleChange("selectedIncludedOutlets", value)}
                                            isDisabled={!!selections?.selectedExcludedOutlets?.length}
                                        />

                                        {/* SELECT EXCLUDED OUTLETS */}
                                        <MultiSelectComponent
                                            label="Select Excluded Outlets"
                                            placeholder="Select Excluded Outlets"
                                            value={selections.selectedExcludedOutlets || []}
                                            onChange={(value) => handleChange("selectedExcludedOutlets", value)}
                                            options={outletData.filter(
                                                (outlet) =>
                                                    !selections.selectedIncludedOutlets?.some(
                                                        (includedOutlet) => includedOutlet.value === outlet.value
                                                    )
                                            )}
                                            isDisabled={!!selections.selectedIncludedOutlets?.length}
                                        />

                                        {/* SELECT APPLICABLE LEVELS */}
                                        <MultiSelectComponent
                                            label="Select Applicable Levels"
                                            placeholder="Select Applicable Levels"
                                            value={selections.selectedApplicableLevels || []}
                                            onChange={(value) => handleChange("selectedApplicableLevels", value)}
                                            options={levelsData}
                                        />

                                        {/* SELECT APPLICABLE PRODUCTS */}
                                        <MultiSelectComponent
                                            label="Select Applicable Products"
                                            placeholder="Select Applicable Products"
                                            value={selections.selectedApplicableProducts || []}
                                            onChange={(value) => handleChange("selectedApplicableProducts", value)}
                                            options={productsInfo}
                                            isDisabled={!!selections.selectedApplicableCategories?.length || couponData.isBogoCoupon || couponData?.isComboCategoryCoupon || couponData.isFreebieCoupon}
                                        />

                                        {/* SELECT APPLICABLE CATEGORIES */}
                                        <MultiSelectComponent
                                            label="Select Applicable Categories"
                                            placeholder="Select Applicable Categories"
                                            value={selections.selectedApplicableCategories || []}
                                            onChange={(value) => handleChange("selectedApplicableCategories", value)}
                                            options={categoriesData}
                                            isDisabled={!!selections.selectedApplicableProducts?.length || couponData?.isComboCategoryCoupon || couponData.isFreebieCoupon}
                                        />

                                        {/* SELECT DEPENDENT CATEGORIES */}
                                        <MultiSelectComponent
                                            label="Select Dependent Categories"
                                            placeholder="Select Dependent Categories"
                                            value={selections.selectedDependentCategories || []}
                                            onChange={(value) => handleChange("selectedDependentCategories", value)}
                                            options={categoriesData}
                                            isDisabled={couponData.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isComboCategoryCoupon || couponData.isFreebieCoupon}
                                        />

                                        {/* SELECT DEPENDENT PRODUCTS */}
                                        <MultiSelectComponent
                                            label="Select Dependent Products"
                                            placeholder="Select Dependent Products"
                                            value={selections.selectedDependentProducts || []}
                                            onChange={(value) => handleChange("selectedDependentProducts", value)}
                                            options={productsInfo}
                                            isDisabled={couponData.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isComboCategoryCoupon || couponData.isFreebieCoupon}
                                        />

                                        {/* SELECT EXCLUDED PRODUCTS */}
                                        <MultiSelectComponent
                                            label="Select Excluded Products"
                                            placeholder="Select Excluded Products"
                                            value={selections.selectedExcludedProducts || []}
                                            onChange={(value) => handleChange("selectedExcludedProducts", value)}
                                            options={exProductsInfo}
                                        />

                                        {/* SELECT EXCLUDING ADDON GROUPS */}
                                        <Col md={6} className='mb-3'>
                                            <Form.Label className="fw-semibold">
                                                Select Excluding Addon Groups
                                            </Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                isMulti
                                                options={allAddonList.map(addon => ({
                                                    value: addon._id,
                                                    label: addon.title
                                                }))}
                                                value={selectedAddonGroups}
                                                onChange={(options) => handleSelectAllAddonChange('excludedAddonGroups', options)}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Select addon groups..."
                                                isDisabled={couponData.isFreebieCoupon}
                                            />
                                        </Col>

                                        {/* SELECT EXCLUDING ADDON VALUES */}
                                        <Col md={6} className='mb-3'>
                                            <Form.Group>
                                                <Form.Label className='fw-semibold'>Select Excluding Addon Values</Form.Label>
                                                <Select
                                                    components={animatedComponents}
                                                    isMulti
                                                    options={filteredAddonValues}
                                                    value={selectedAddonValues}
                                                    onChange={handleAddonValueChange}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    placeholder="Select addon values to exclude..."
                                                    getOptionLabel={(option) => option.label}
                                                    getOptionValue={(option) => `${option.value.addonId}-${option.value.addonValueId}`}
                                                    isDisabled={selectedAddonGroups.length === 0 || couponData.isFreebieCoupon}
                                                />
                                            </Form.Group>
                                        </Col>

                                        {/* PRIMARY COMBO CATEGORIES */}
                                        <MultiSelectComponent
                                            label="Select Primary Combo Categories"
                                            placeholder="Select Primary Combo Categories"
                                            value={selections.primaryComboCategories || []}
                                            onChange={(value) => handleChange("primaryComboCategories", value)}
                                            options={categoriesData.filter(
                                                (category) =>
                                                    !selections.secondaryComboCategories?.some(
                                                        (cat) => cat.value === category.value
                                                    )
                                            )}
                                            isDisabled={couponData.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isMrpDiscount || couponData.isFreebieCoupon}
                                        />

                                        {/* SECONDARY COMBO CATEGORIES */}
                                        <MultiSelectComponent
                                            label="Select Secondary Combo Categories"
                                            placeholder="Select Secondary Combo Categories"
                                            value={selections.secondaryComboCategories || []}
                                            onChange={(value) => handleChange("secondaryComboCategories", value)}
                                            options={categoriesData.filter(
                                                (category) =>
                                                    !selections.primaryComboCategories?.some(
                                                        (cat) => cat.value === category.value
                                                    )
                                            )}
                                            isDisabled={couponData.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isMrpDiscount || couponData.isFreebieCoupon}
                                        />

                                        {/* SELECT SIZE UPGRADE ADDON */}
                                        <Col md={3}>
                                            <Form.Label className="fw-semibold">
                                                Select Size Upgrade Addons <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="newSizeUpgradeAddon"
                                                value={couponData.newSizeUpgradeAddon}
                                                onChange={(e) => setCouponData((prev) => ({
                                                    ...prev,
                                                    newSizeUpgradeAddon: e.target.value,
                                                }))}
                                                disabled={couponData?.isComboCategoryCoupon || couponData?.isBogoCoupon || couponData?.isMrpDiscount || couponData.isFreebieCoupon}
                                            >
                                                <option value="">Select Size Upgrade Addon</option>
                                                {newSizeAddonsList?.map((addon) => (
                                                    <option key={addon._id} value={addon._id}>{addon.title} [{addon.identifier}]</option>
                                                ))}
                                            </Form.Select>
                                        </Col>

                                        {/* HIDE COUPON */}
                                        <Col md={3} className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Hide Coupon <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="isHidden"
                                                value={couponData.isHidden}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select Option</option>
                                                <option value="true">YES</option>
                                                <option value="false">NO</option>
                                            </Form.Select>
                                        </Col>

                                        {/* ORDER TYPE */}
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label className='fw-semibold'>
                                                    Order Type <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="orderType"
                                                    value={couponData.orderType || "ALL"}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="ALL">ALL</option>
                                                    <option value="DELIVERY">DELIVERY</option>
                                                    <option value="PICKUP">PICK-UP</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        {/* Max Addons Allowed */}
                                        <Col md={3} className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Max Addons Allowed
                                            </Form.Label>
                                            <Form.Control
                                                min={0}
                                                placeholder="Max Addons Allowed"
                                                type="number"
                                                name="maxAddonsAllowed"
                                                value={couponData.maxAddonsAllowed || null}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value)) {
                                                        handleInputChange(e);
                                                    }
                                                }}
                                            // disabled={couponData.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isMrpDiscount}
                                            />
                                        </Col>

                                        {/* Discount Percent */}
                                        <Col md={3}>
                                            <Form.Label className="fw-semibold">
                                                Discount Percent <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                min={0}
                                                max={100}
                                                disabled={
                                                    couponData?.discountAmount || couponData?.discountPrice || couponData?.isBogoCoupon || couponData.isSizeUpgradeCoupon || couponData.isFreebieCoupon
                                                }
                                                placeholder="Discount Percent"
                                                type="number"
                                                name="discountPercent"
                                                value={couponData.discountPercent || ""}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {/* Maximum Discount Amount */}
                                        <Col md={3}>
                                            <Form.Label className="fw-semibold">
                                                Max. Dis. Amount
                                            </Form.Label>
                                            <Form.Control
                                                min={0}
                                                disabled={couponData.isBogoCoupon || couponData.isSizeUpgradeCoupon || couponData.discountAmount !== "" || couponData.discountPrice || couponData.isFreebieCoupon}
                                                placeholder="Max. Dis. Amount"
                                                type="number"
                                                name="maxDiscountAmount"
                                                value={couponData.maxDiscountAmount}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {/* Discount Amount */}
                                        <Col md={3}>
                                            <Form.Label className="fw-semibold">
                                                Discount Amount <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                min={0}
                                                step={0.01}
                                                disabled={
                                                    couponData?.discountPercent || couponData?.discountPrice || couponData?.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isMrpDiscount || couponData.isFreebieCoupon
                                                }
                                                placeholder="Discount Amount"
                                                type="number"
                                                name="discountAmount"
                                                value={couponData.discountAmount ?? ""}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {/* Discount Price */}
                                        <Col md={3}>
                                            <Form.Label className="fw-semibold">
                                                Discount Price <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                min={0}
                                                step={0.01}
                                                disabled={
                                                    couponData?.discountAmount || couponData?.discountPercent || couponData?.isBogoCoupon || couponData.isSizeUpgradeCoupon || couponData?.isMrpDiscount || couponData.isFreebieCoupon
                                                }
                                                placeholder="Discount Price"
                                                type="number"
                                                name="discountPrice"
                                                value={couponData.discountPrice || ""}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {/* Applicable Quantity Type */}
                                        <Col className='mt-3' md={3}>
                                            <Form.Label className="fw-semibold">
                                                Applicable Qty Type <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="applicableQuantityType"
                                                value={couponData.applicableQuantityType || ""}
                                                onChange={handleInputChange}
                                                disabled={
                                                    couponData?.discountPercent || couponData?.discountAmount || couponData?.isBogoCoupon || couponData.isSizeUpgradeCoupon || couponData?.isMrpDiscount
                                                }
                                            >
                                                <option value="">Select Applicable Qty Type</option>
                                                <option value="SINGLE">SINGLE</option>
                                                {!couponData?.isComboCategoryCoupon && <option value="MULTIPLE">MULTIPLE</option>}
                                            </Form.Select>
                                        </Col>

                                        {/* Min. Order Amount */}
                                        <Col md={3} lg={3} className="mt-3">
                                            <Form.Label className="fw-semibold">
                                                Min. Order Amount
                                            </Form.Label>
                                            <Form.Control
                                                min={0}
                                                placeholder="Min. Order Amount"
                                                type="number"
                                                name="minOrderAmount"
                                                value={couponData.minOrderAmount}
                                                onChange={handleInputChange}
                                            />
                                        </Col>

                                        {/* Is Mrp Coupon? */}
                                        <Col md={3} className="mt-3">
                                            <Form.Label className="fw-semibold">
                                                Is Mrp Coupon? <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="isMrpDiscount"
                                                value={couponData.isMrpDiscount}
                                                onChange={handleInputChange}
                                                disabled={couponData?.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isComboCategoryCoupon || couponData.isFreebieCoupon}
                                            >
                                                <option value="">Select Option</option>
                                                <option value="true">YES</option>
                                                <option value="false">NO</option>
                                            </Form.Select>
                                        </Col>

                                        {/* Description */}
                                        <Col md={12} className="mt-3">
                                            <Form.Label className="fw-semibold">
                                                Description <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                placeholder="Description"
                                                name="description"
                                                value={couponData.description || ""}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        {/* Other fields */}
                                        <Col md={12} className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Terms and Conditions <span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="d-flex mb-2">
                                                <Form.Control
                                                    placeholder="Add a term"
                                                    value={currentTerm}
                                                    onChange={(e) => setCurrentTerm(e.target.value)}
                                                    className="me-2"
                                                />
                                                <Button disabled={!currentTerm.trim()} onClick={addTerm}>ADD</Button>
                                            </div>
                                            {couponData?.termsAndConditions?.length > 0 && (
                                                <ListGroup>
                                                    {couponData?.termsAndConditions?.map((term, index) => (
                                                        <ListGroup.Item
                                                            key={index}
                                                            className="d-flex justify-content-between align-items-center"
                                                        >
                                                            {term}
                                                            <Button
                                                                variant="danger"
                                                                size="sm"
                                                                onClick={() => removeTerm(index)}
                                                            >
                                                                Remove
                                                            </Button>
                                                        </ListGroup.Item>
                                                    ))}
                                                </ListGroup>
                                            )}
                                        </Col>
                                        {/* Rest of your form fields */}
                                        {/* ... */}
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="primary"
                                        disabled={isLoading}
                                        type="submit"
                                    >
                                        {isLoading ? 'Adding...' : 'ADD USER COUPON ALLOCATION'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {/* View Details Modal */}
                    {openViewModal && (
                        <Modal
                            centered
                            show={openViewModal}
                            onHide={() => setOpenViewModal(false)}
                            size="xl"
                        >
                            <Modal.Header closeButton style={{ backgroundColor: "#f8f9fa", borderBottom: "1px solid #dee2e6" }}>
                                <Modal.Title id="VerticallyCenteredExample" className="fs-5 fw-bold text-primary">
                                    VIEW USER COUPON ALLOCATION DETAILS
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>
                                {/* Coupon Details Section */}
                                <div className="mb-4">
                                    <h5 className="text-center fw-bold text-primary mb-3">COUPON DETAILS</h5>
                                    <Table bordered hover>
                                        <tbody>
                                            <tr>
                                                <td className='w-50 fw-semibold'>Title</td>
                                                <td>{couponDetails?.title}</td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>Description</td>
                                                <td>{couponDetails?.description}</td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>Coupon Code</td>
                                                <td className='fw-bold' style={{ color: 'blueviolet' }}>{couponDetails?.couponCode}</td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>Usage-Type</td>
                                                <td>{couponDetails?.usageType}</td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>Order Type</td>
                                                <td>{couponDetails?.orderType}</td>
                                            </tr>
                                            {couponDetails?.dayOfWeek === null && (
                                                <tr>
                                                    <td className='fw-semibold'>Applicable Days</td>
                                                    <td>On any day of the week</td>
                                                </tr>
                                            )}
                                            {couponDetails?.dayOfWeek && (
                                                <tr>
                                                    <td className='fw-semibold'>Applicable Days</td>
                                                    <td>
                                                        {couponDetails?.dayOfWeek !== undefined ? getDayOfWeek(couponDetails.dayOfWeek) : couponDetails?.dayOfWeek === 'all' ? 'On any day of the week' : "N/A"}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.maxAddonsAllowed && (
                                                <tr>
                                                    <td className='fw-semibold'>Maximum Addon Allowed</td>
                                                    <td>{couponDetails?.maxAddonsAllowed}</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td className='fw-semibold'>BOGO Coupon</td>
                                                <td>
                                                    {couponDetails?.isBogoCoupon ? <span className='text-success fw-semibold'>YES </span> : <span className='text-danger fw-semibold'>NO </span>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>Size Upgrade Coupon</td>
                                                <td>
                                                    {couponDetails?.newSizeUpgradeAddon ? <span className='text-success fw-semibold'>YES </span> : <span className='text-danger fw-semibold'>NO </span>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>Combo Category Coupon</td>
                                                <td>
                                                    {couponDetails?.isComboCategoryCoupon ? <span className='text-success fw-semibold'>YES </span> : <span className='text-danger fw-semibold'>NO </span>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>MRP Coupon</td>
                                                <td>
                                                    {couponDetails?.isMrpDiscount ? <span className='text-success fw-semibold'>YES </span> : <span className='text-danger fw-semibold'>NO </span>}
                                                </td>
                                            </tr>
                                            {couponDetails?.isFreebieCoupon && (
                                                <>
                                                    <tr>
                                                        <td className='fw-semibold'>Freebie Product</td>
                                                        <td className='text-success fw-semibold'>
                                                            {couponDetails?.freebieProduct?.name || "N/A"}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-semibold'>Freebie Quantity</td>
                                                        <td className='text-success fw-semibold'>
                                                            {couponDetails?.freebieQuantity || 1}
                                                        </td>
                                                    </tr>
                                                </>
                                            )}
                                            {couponDetails?.applicableCategories?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Applicable Categories</td>
                                                    <td>
                                                        {couponDetails?.applicableCategories.map((item) => item?.name).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.excludedProducts?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Excluded Products</td>
                                                    <td>
                                                        {couponDetails?.excludedProducts.map((item) => item?.name).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.applicableProducts?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Applicable Products</td>
                                                    <td>
                                                        {couponDetails?.applicableProducts.map((item) => item?.name).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {/* Excluded Addons Section - Grouped Version */}
                                            {couponDetails?.excludedAddons?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Excluded Addons</td>
                                                    <td>
                                                        {(() => {
                                                            const groupedAddons = couponDetails.excludedAddons.reduce((acc, addon) => {
                                                                if (!acc[addon.addonTitle]) {
                                                                    acc[addon.addonTitle] = [];
                                                                }
                                                                acc[addon.addonTitle].push(addon.addonValueTitle);
                                                                return acc;
                                                            }, {});

                                                            return Object.entries(groupedAddons).map(([addonTitle, values]) => (
                                                                <div key={addonTitle}>
                                                                    <strong>{addonTitle}</strong>: {values.join(', ')}
                                                                </div>
                                                            ));
                                                        })()}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.applicableLevels?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Applicable Levels</td>
                                                    <td>
                                                        {couponDetails?.applicableLevels.map((item) => item?.title).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.dependantCategories?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Dependant Categories</td>
                                                    <td>
                                                        {couponDetails?.dependantCategories.map((item) => item?.name).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.dependantProducts?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Dependant Products</td>
                                                    <td>
                                                        {couponDetails?.dependantProducts.map((item) => item?.name).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.includedOutlets?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Included Outlets</td>
                                                    <td>
                                                        {couponDetails?.includedOutlets.map((item) => item?.name).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.excludedOutlets?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Excluded Outlets</td>
                                                    <td>
                                                        {couponDetails?.excludedOutlets.map((item) => item?.name).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.primaryComboCategories?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Primary Combo Categories</td>
                                                    <td>
                                                        {couponDetails?.primaryComboCategories.map((item) => item?.name).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.secondaryComboCategories?.length > 0 && (
                                                <tr>
                                                    <td className='fw-semibold'>Secondary Combo Categories</td>
                                                    <td>
                                                        {couponDetails?.secondaryComboCategories.map((item) => item?.name).join(', ')}
                                                    </td>
                                                </tr>
                                            )}
                                            {couponDetails?.applicableQuantityType && (
                                                <tr>
                                                    <td className='fw-semibold'>Applicable Quantity Type</td>
                                                    <td>{couponDetails?.applicableQuantityType}</td>
                                                </tr>
                                            )}
                                            {couponDetails?.discountPrice && (
                                                <tr>
                                                    <td className='fw-semibold'>Discount Price</td>
                                                    <td className='text-success fw-semibold'>₹. {couponDetails?.discountPrice}</td>
                                                </tr>
                                            )}
                                            {couponDetails?.discountPercent && (
                                                <tr>
                                                    <td className='fw-semibold'>Discount Percent</td>
                                                    <td className='text-success fw-semibold'>{couponDetails?.discountPercent} % OFF</td>
                                                </tr>
                                            )}
                                            {couponDetails?.discountAmount && (
                                                <tr>
                                                    <td className='fw-semibold'>Discount Amount</td>
                                                    <td className='text-success fw-semibold'>₹. {couponDetails?.discountAmount}</td>
                                                </tr>
                                            )}
                                            {couponDetails?.minOrderAmount && (
                                                <tr>
                                                    <td className='fw-semibold'>Minimum Order Amount</td>
                                                    <td className='text-success fw-semibold'>₹. {couponDetails?.minOrderAmount}</td>
                                                </tr>
                                            )}
                                            {couponDetails?.maxDiscountAmount && (
                                                <tr>
                                                    <td className='fw-semibold'>Maximum Discount Amount</td>
                                                    <td className='text-success fw-semibold'>₹. {couponDetails?.maxDiscountAmount}</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td className='fw-semibold'>Start Time</td>
                                                <td className='fw-bold' style={{ color: 'blueviolet' }}>{couponDetails?.startTime}</td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>End Time</td>
                                                <td className='fw-bold' style={{ color: 'blueviolet' }}>{couponDetails?.endTime}</td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>Valid From</td>
                                                <td>{formattedDate(couponDetails?.validityStartDate)}</td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>Valid Till</td>
                                                <td>{formattedDate(couponDetails?.validityEndDate)}</td>
                                            </tr>
                                            <tr>
                                                <td className='fw-semibold'>Status</td>
                                                <td>
                                                    <Badge bg={checkCouponActive(couponDetails) ? "success" : "danger"}>
                                                        {checkCouponActive(couponDetails) ? "ACTIVE" : "INACTIVE (Expired)"}
                                                    </Badge>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Terms and Conditions Section */}
                                {couponDetails?.termsAndConditions?.length > 0 && (
                                    <div className="mb-4">
                                        <h5 className="text-center fw-bold text-primary mb-3">TERMS AND CONDITIONS</h5>
                                        <Table bordered hover>
                                            <tbody>
                                                {couponDetails?.termsAndConditions?.map((term, index) => (
                                                    <tr key={index}>
                                                        <td className="fw-semibold text-center">{index + 1}.</td>
                                                        <td>{term}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}

                                {/* Users Details Section */}
                                <div className="mb-4">
                                    <h5 className="text-center fw-bold text-primary mb-3">USERS DETAILS</h5>
                                    <Table bordered hover>
                                        <thead>
                                            <tr>
                                                <th className="text-center">SR. No</th>
                                                <th className="text-center">NAME</th>
                                                <th className="text-center">EMAIL ID</th>
                                                <th className="text-center">D.O.B</th>
                                                <th className="text-center">GENDER</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {couponUsers?.map((user, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">{index + 1}.</td>
                                                    <td className="text-center">{user?.name}</td>
                                                    <td className="text-center">{user?.email}</td>
                                                    <td className="text-center">{user?.dob ? formattedDate(user?.dob) : "---"}</td>
                                                    <td className="text-center">{user?.gender ? user.gender : "---"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Modal.Body>
                            <Modal.Footer style={{ backgroundColor: "#f8f9fa", borderTop: "1px solid #dee2e6" }}>
                                <Button
                                    style={{ borderRadius: "18px", padding: "8px 20px" }}
                                    variant="primary"
                                    onClick={() => setOpenViewModal(false)}
                                >
                                    CLOSE
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                    {/* Edit Modal */}
                    <EditModal
                        isVisible={openEditModal}
                        selectedUsers={selectedUsers}
                        setOpenEditModal={setOpenEditModal}
                        setFile={setFile}
                        setSelectedUsers={setSelectedUsers}
                        setCouponData={setCouponData}
                        setFromDate={setFromDate}
                        setToDate={setToDate}
                        setSelectedCategories={setSelectedCategories}
                        setSelectedProducts={setSelectedProducts}
                        userCouponId={userCouponId}
                        fetchData={fetchData}
                        selectedCategories={selectedCategories}
                        selectedProducts={selectedProducts}
                        addonList={addonList}
                        getProductsList={getProductsList}
                        usersInfo={usersInfo}
                        handleSelectUsersChange={handleSelectUsersChange}
                        debouncedGetUsersList={debouncedGetUsersList}
                        categoriesData={categoriesData}
                        handleSelectCategoryChange={handleSelectCategoryChange}
                        productsInfo={productsInfo}
                        handleSelectProductChange={handleSelectProductChange}
                        editOutletData={editOutletData}
                        outletData={outletData}
                        levelsData={levelsData}
                        updatingData={updatingData}
                        setUserCouponId={setUserCouponId}
                        exProductList={exProductList}
                        newSizeAddonsList={newSizeAddonsList}
                        allAddonList={allAddonList}
                        freebieProductsOptions={freebieProductsOptions}
                    />

                    {/* Delete Modal */}
                    <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete this user allocation? This action cannot be undone.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={handleDeleteUserCouponAllocation}>
                                {isDeleteLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    "Delete User Coupon"
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>

            <style jsx>{`
                .rotate-180 {
                    transform: rotate(180deg);
                    transition: transform 0.2s ease;
                }
                .accordion-button:not(.collapsed) {
                    background-color: #f8f9fa;
                }
                .avatar-sm {
                    width: 32px;
                    height: 32px;
                }
                .avatar-title {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                    font-weight: bold;
                }
            `}</style>
        </React.Fragment>
    );
};

export default NewUserCoupon;